"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var SingleLineViewListItem_1 = require("./SingleLineViewListItem");
var ThreeLineViewListItem_1 = require("./ThreeLineViewListItem");
var owa_mail_messagead_orchestration_1 = require("owa-mail-messagead-orchestration");
var mobx_react_1 = require("mobx-react");
var owa_mail_messagead_action_1 = require("owa-mail-messagead-action");
var React = require("react");
var owa_messagead_strings_1 = require("owa-strings/owa-messagead-strings");
var owa_analytics_1 = require("owa-analytics");
require("external-fan-prebid");
var styles = require('./MessageAdListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var MessageAdListItem = /** @class */ (function (_super) {
    tslib_1.__extends(MessageAdListItem, _super);
    function MessageAdListItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelectItem = function (evt) {
            evt.stopPropagation();
            owa_mail_messagead_action_1.selectMessageAd(_this.props.messageAd.adId);
        };
        return _this;
    }
    MessageAdListItem.prototype.componentDidMount = function () {
        var _this = this;
        this.previousIsReadingPanePositionOff = this.props.isReadingPanePositionOff;
        if (this.props.messageAd.adFanBidId) {
            var data = {
                placementid: '1962231667378978_2050883985180412',
                bidid: this.props.messageAd.adFanBidId,
                format: 'native',
                testmode: false,
                onAdLoaded: function (element) {
                    owa_analytics_1.logUsage('NativeAdsFANLoaded', {
                        adType: _this.props.messageAd.adType,
                        adMarket: _this.props.messageAd.adMarket,
                        adRefreshEvent: _this.props.messageAd.adRefreshEvent,
                    });
                },
                onAdError: function (errorCode, errorMessage) {
                    owa_analytics_1.logUsage('NativeAdsFANLoadError', {
                        adType: _this.props.messageAd.adType,
                        adMarket: _this.props.messageAd.adMarket,
                        adRefreshEvent: _this.props.messageAd.adRefreshEvent,
                        adErrorCode: errorCode,
                        adErrorMessage: errorMessage,
                    });
                    owa_mail_messagead_orchestration_1.loadMessageAdList('fanFailReLoad');
                },
            };
            window.data = data;
            window.pbjs.renderFaceBookAd();
        }
    };
    MessageAdListItem.prototype.componentDidUpdate = function () {
        if (this.props.isReadingPanePositionOff != this.previousIsReadingPanePositionOff) {
            this.previousIsReadingPanePositionOff = this.props.isReadingPanePositionOff;
            owa_mail_messagead_orchestration_1.loadMessageAdList('readingPanePostionChange');
        }
    };
    MessageAdListItem.prototype.render = function () {
        var _this = this;
        var adSender = this.props.messageAd.adSender;
        var adSubject = this.props.messageAd.adSubject;
        var adPreviewTexts = this.props.messageAd.adPreviewTexts;
        if (this.props.messageAd.adType === "OutlookUpSell" /* OutlookUpSell */) {
            adSender = owa_messagead_strings_1.default.outlookAdSenderText;
            adSubject = owa_messagead_strings_1.default.outlookAdSubject;
            adPreviewTexts = owa_messagead_strings_1.default.outlookAdPreview;
        }
        // Outer container CSS classes that are shared between 3 column and single line views
        var backgroundColorClass;
        var shouldBackgroundChangeOnHover = true;
        if (this.props.isSelected) {
            backgroundColorClass = styles.selectedMailListItemColor;
            shouldBackgroundChangeOnHover = false;
        }
        else {
            backgroundColorClass = styles.regularMailListItemColor;
        }
        // Outer container CSS classes that are shared between 3 column and single line views
        var mailListItemOuterContainerClasses = classNames(styles.mailListItem, backgroundColorClass, shouldBackgroundChangeOnHover && styles.backgroundChangeOnHover, styles.showHoverActionsOnHover, !this.props.messageAd.isRead && styles.unreadMailListItem);
        return (React.createElement("div", { className: classNames(styles.messageAdBoxContainer, 'thirdPartyRoot') },
            React.createElement("div", { className: mailListItemOuterContainerClasses, onClick: function (evt) {
                    _this.onSelectItem(evt);
                } }, this.props.isReadingPanePositionOff ? (React.createElement("div", { className: styles.mailListItemContainer },
                React.createElement(SingleLineViewListItem_1.default, { isUnread: !this.props.messageAd.isRead, isSelected: this.props.isSelected, senderLineTexts: adSender, subjectLineTexts: adSubject, previewLineTexts: adPreviewTexts, iconBarUrl: this.props.messageAd.adChoiceUrl, originalPriceTexts: this.props.messageAd.adOriginalPrice, currentPriceTexts: this.props.messageAd.adCurrentPrice, adId: this.props.messageAd.adId }))) : (React.createElement("div", { className: styles.mailListItemContainer },
                React.createElement(ThreeLineViewListItem_1.default, { isUnread: !this.props.messageAd.isRead, isSelected: this.props.isSelected, senderLineTexts: adSender, subjectLineTexts: adSubject, previewLineTexts: adPreviewTexts, iconBarUrl: this.props.messageAd.adChoiceUrl, originalPriceTexts: this.props.messageAd.adOriginalPrice, currentPriceTexts: this.props.messageAd.adCurrentPrice, adId: this.props.messageAd.adId }))))));
    };
    MessageAdListItem = tslib_1.__decorate([
        mobx_react_1.observer
    ], MessageAdListItem);
    return MessageAdListItem;
}(React.Component));
exports.default = MessageAdListItem;
//# sourceMappingURL=MessageAdListItem.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/MessageAdListItem.js
// module id = 5995
// module chunks = 67